import fetch from "../utils/fetch";
import { setAllowRedirect, showLoader } from "./appActions";
import { redirectTo, alertBackendError } from "../utils";
import {find, forEach} from "lodash";
import * as InstanceRoles from "../Atollon/Instance/InstanceRoles";

import {

    RESOURCES_organizationPackageMapping,
    RESOURCES_organizationPackageMapping_forOrg,

    RESOURCES,
    RESOURCES_HOST,
    RESOURCES_SERVERS,
    RESOURCES_SERVER,
    RESOURCES_ORGANIZATION,
    RESOURCES_ORGANIZATIONS,
    RESOURCES_USER_ORGANIZATION,
    RESOURCES_organizationUserDetails,

    USER_CAN_USER_EDIT_INSTANCE
} from "../actions/constants";
import {getApiPrefix_lagoon, getApiPrefix_touch} from "../constants";

export const clearHosts = () => ({
  type: RESOURCES,
  payload: { hosts: null }
});

export const getRequestResource = ({
  role,
  type,
  relationRole,
  lang,
  nameContains,
  includeMyself,
  showAllForAdmin
}) => async (dispatch, getState) => {
  let query = "";

  query += `${role ? (query === "" ? `role=${role}` : `&role=${role}`) : ""}`;
  query += `${type ? (query === "" ? `type=${type}` : `&type=${type}`) : ""}`;
  query += `${relationRole
    ? query === ""
      ? `relationRole=${relationRole}`
      : `&relationRole=${relationRole}`
    : ""}`;
  query += `${lang ? (query === "" ? `lang=${lang}` : `&lang=${lang}`) : ""}`;
  query += `${nameContains
    ? query === ""
      ? `nameContains=${nameContains}`
      : `&nameContains=${nameContains}`
    : ""}`;

  if( includeMyself )
  {
    query += ( query? '&' : '' ) + 'includeMyself=true';  // M: by default searching does not include information about user who searches
  }

  if( showAllForAdmin )
  {
    query += ( query? '&' : '' ) + 'showAllForAdmin=true';  // M: admin sees all
  }

  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource?${query}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      return content;
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getProviders = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      role: "PROVIDER",
      type: "ORGANIZATION,PERSON"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { providers: response ? response : null }
  });

  return response;
};

export const getProjects = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      type: "PROJECT"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { projects: response ? response : null }
  });

  return false;
};

export const getOrganizations = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "ADMIN,DISPATCHER,MEMBER",
      type: "ORGANIZATION"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizations: response ? response : null }
  });

  return false;
};

export const getContacts = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      type: "ORGANIZATION,PERSON"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { contacts: response ? response : null }
  });

  return response;
};

export const getClients = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      role: "CLIENT",
      type: "ORGANIZATION,PERSON"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { clients: response ? response : null }
  });

  return response;
};

export const getDispatchers = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "ADMIN,DISPATCHER",
      type: "ORGANIZATION,PERSON"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { dispatchers: response ? response : null }
  });

  return response;
};

export const getAdminOrganizations = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "ADMIN",
      type: "ORGANIZATION"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationsAdmin: response ? response : null }
  });

  return false;
};

export const getDispatcherOrganizations = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "DISPATCHER",
      type: "ORGANIZATION"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationsDispatcher: response ? response : null }
  });

  return false;
};

export const getMemberOrganizations = () => async (dispatch, getState) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "MEMBER",
      type: "ORGANIZATION"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationsMember: response ? response : null }
  });

  return false;
};

export const getAdminDispatcherOrganizations = () => async (
  dispatch,
  getState
) => {
  const response = await dispatch(
    getRequestResource({
      relationRole: "ADMIN,DISPATCHER",
      type: "ORGANIZATION"
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationsAdminDispatcher: response ? response : null }
  });

  return false;
};

export const getOrganizationsWithoutRelationRole = ({ showAllForAdmin, includeMyself } = {}) => async (
  dispatch,
  getState
) => {
  const response = await dispatch(
    getRequestResource({
      type: "ORGANIZATION",
      showAllForAdmin,
      includeMyself
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { organizations: response ? response : null }
  });

  return false;
};

export const getTypeBySearch = (type, nameContains, includeMyself) => async (
  dispatch,
  getState
) => {

  includeMyself = includeMyself || false;

  const response = await dispatch(
    getRequestResource({
      type,
      lang: "cs",
      nameContains,
      includeMyself: includeMyself // M: by default searching does not include information about user who searches
    })
  );

  dispatch({
    type: RESOURCES,
    payload: { users: response ? response : null }
  });

  return false;
};

export const getProject = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${id}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      dispatch({
        type: RESOURCES,
        payload: { project: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getPerson = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${id}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      dispatch({
        type: RESOURCES,
        payload: { person: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getOrganizationNormal = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${id}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      dispatch({
        type: RESOURCES,
        payload: { organization: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateOrganizationNormal = organization => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${organization.identifier}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(organization)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateRequestResource = resource => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${resource.identifier}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(resource)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};


/**************************/
// NEW CALLS
/**************************/

export const getHost = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/host/${id ? id : ""}`);

    if (response.status === 200) {
      const content = await response.json();

      if (id) {
        dispatch({
          type: RESOURCES_HOST,
          payload: { host: content }
        });
      } else {
        dispatch({
          type: RESOURCES,
          payload: { hosts: content }
        });
      }
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getServer = (hostId, serverId) => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/server/${serverId ? serverId : ""}`
    );

    if (response.status === 200) {
      const content = await response.json();

      if (serverId) {
        dispatch({
          type: RESOURCES_SERVER,
          payload: { server: content, hostId }
        });
      } else {
        dispatch({
          type: RESOURCES_SERVERS,
          payload: { servers: content, hostId }
        });
      }
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getOrganization = (hostId, serverId, organizationId) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId ? organizationId : ""}`
    );

    if (response.status === 200) {
      const content = await response.json();

      if (organizationId) {
        dispatch({
          type: RESOURCES_ORGANIZATION,
          payload: { organization: content, hostId, serverId }
        });
      } else {
        dispatch({
          type: RESOURCES_ORGANIZATIONS,
          payload: { organizations: content, hostId, serverId }
        });
      }
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded = () => async (dispatch, getState) => {

    let state  = getState();

    //
    // console.log('canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded', {'userOrganizations': state.resource.userOrganizations, state});
    forEach( state.resource.userOrganizations, async instance => {

        let { id, atollonId, ident } = instance;
        let organizationId = instance.id;

        // console.log('canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded', {organizationId});

        // get users which can edit organization

        let get_fn;
        let get_y;

        get_fn = getOrganizationUsersAdmin(organizationId);
        get_y = await get_fn( dispatch, getState ); // wait for completion of ajax


        // is current user user which can edit this organization

        // console.log( '[[ resource ]]', getState().resource);
        // console.log( '[[ resource > organizationUsersAdmin ]]', getState().resource.organizationUsersAdmin);

        // console.log('canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded', {'organizationUsersAdmin': getState().resource.organizationUsersAdmin, state: getState()});

        let usersList = [];
        forEach( getState().resource.organizationUsersAdmin, adminUser => {

          // let {id, name} = adminUser; // atollon id ???
          // let userId = id;
            usersList.push( adminUser );
        });

        get_fn = getOrganizationUsersOwner(organizationId);
        get_y = await get_fn( dispatch, getState ); // wait for completion of ajax

        // console.log('canUserEditThisOrganization_init_mustRunAfterOrganizationsAreDownloaded', {'organizationUsersOwner': getState().resource.organizationUsersOwner, state: getState()});
        forEach( getState().resource.organizationUsersOwner, adminUser => {

            // let {id, name} = adminUser; // atollon id ???
            // let userId = id;
            usersList.push( adminUser );
        });

        dispatch({
              type: USER_CAN_USER_EDIT_INSTANCE,
              payload: {
                usersList: usersList,
                canEdit: true,
                instanceId: organizationId
              }
        });
    });
};

export const getUserOrganizations = (typeOrId,myAtollon_setAsSelected=false) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/organization/${typeOrId}`);

    if (response.status === 200) {
      const content = await response.json();

      if (typeOrId) {
        if (
          typeOrId === "related" ||
          typeOrId === "owned" ||
          typeOrId === "administered"
        ) {

          let payload = {
              userOrganizations: content,
          };

          InstanceRoles.addToDispatchPayload( payload, typeOrId, content );

          payload.userOrganizations_byType = {};
          payload.userOrganizations_byType[typeOrId] = content;

          if( myAtollon_setAsSelected )
          {
              payload.myAtollon_selectedUserOrganizationTypeName = typeOrId;
          }

          dispatch({
            type: RESOURCES,
            payload
          });

        } else {
          dispatch({
            type: RESOURCES_USER_ORGANIZATION,
            payload: {
              userOrganization: content,
            }
          });
        }
      }
      else
      {
          dispatch({
              type: RESOURCES,
              payload: { userOrganizationsAll: content }
          });
      }
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const foundHost = host => async (dispatch, getState) => {
  dispatch(showLoader(true));
  try {
    const response = await fetch(`${getApiPrefix_touch()}/host/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(host)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
      dispatch(showLoader(false));
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
      dispatch(showLoader(false));
    }

    dispatch(showLoader(false));
    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    dispatch(showLoader(false));
    return false;
  }
};

export const foundServer = server => async (dispatch, getState) => {
  dispatch(showLoader(true));
  try {
    const response = await fetch(`${getApiPrefix_touch()}/server/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(server)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
      dispatch(showLoader(false));
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
      dispatch(showLoader(false));
    }

    dispatch(showLoader(false));
    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    dispatch(showLoader(false));
    return false;
  }
};


export const foundOrganization = organization => async (dispatch, getState) => {
  dispatch(showLoader(true));
  try {
    const response = await fetch(`${getApiPrefix_touch()}/organization/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(organization)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
      dispatch(showLoader(false));
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
      dispatch(showLoader(false));
    }

    dispatch(showLoader(false));
    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    dispatch(showLoader(false));
    return false;
  }
};

export const getPackages = organizationId => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/package`
    );

    if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { packages: content }
      });
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const setOrganizationUserDetail = (organizationIdAsNumber, userIdAsEmail, userXMLAsString ) => async (
    dispatch,
    getState
) => {
    try {
        const response = await fetch(
            `${getApiPrefix_touch()}/organization/${organizationIdAsNumber}/user/${userIdAsEmail}/detail`,
            {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/xml"
                }),
                body: userXMLAsString
            }
        );
        if (response.status === 200) {
            const content = await response.text(); // only way to get XML is to obtain it as string

        } else if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};



export const getOrganizationUserDetail = (organizationIdAsNumber, userIdAsEmail) => async (
    dispatch,
    getState
) => {
    try {
        const response = await fetch(
            `${getApiPrefix_touch()}/organization/${organizationIdAsNumber}/user/${userIdAsEmail}/detail`);

        if (response.status === 200) {
            const content = await response.text(); // only way to get XML is to obtain it as string

            let payload = {};
            payload.organizationUserDetails = {};
            payload.organizationUserDetails[userIdAsEmail] = content;

            // when viewing user
            dispatch({
                type: RESOURCES_organizationUserDetails,
                payload: payload
            });
        } else if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

export const getOrganizationUsers = (organizationId, filter, role) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/user${filter &&
      filter !== ""
        ? `?filter=${filter}`
        : ""}${role && role !== ""
        ? filter && filter !== "" ? `&role=${role}` : `?role=${role}`
        : ""}`
    );

    if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { organizationUsers: content }
      });
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getOrganizationUsersByRole = (organizationId, role) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/users?role=${role}`
    );

    if (response.status === 200) {
      const content = await response.json();

      return content;
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return false;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getOrganizationUsersAdmin = organizationId => async dispatch => {
  const response = await dispatch(
    getOrganizationUsersByRole(organizationId, "admin")
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationUsersAdmin: response ? response : null }
  });

  return false;
};

export const getOrganizationUsersOwner = organizationId => async dispatch => {
  const response = await dispatch(
    getOrganizationUsersByRole(organizationId, "owner")
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationUsersOwner: response ? response : null }
  });

  return false;
};

export const getOrganizationUsersUser = organizationId => async dispatch => {
  const response = await dispatch(
    getOrganizationUsersByRole(organizationId, "user")
  );

  dispatch({
    type: RESOURCES,
    payload: { organizationUsersUser: response ? response : null }
  });

  return false;
};

export const getTouchUsers = filter => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/user${filter && filter !== ""
        ? `?filter=${filter}`
        : ""}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { touchUsers: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

/**
 *   DATA for form OrganizationUserAdministration_Dialog.js
 *      [{ id, name }]
 *
 * @param nameContainsAsString
 * @returns {Function}
 */
export const getTouchUsersWithFilter = nameContainsAsString => async (dispatch, getState) => {
    try {
        const response = await fetch(
            `${getApiPrefix_lagoon()}/auth/requestResource?type=PERSON&nameContains=${nameContainsAsString}`
        );

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 200) {
            const content = await response.json();

            // TODO: data format has to be checked properly!
            // FIXME: this should not be converted here !!!!
            let touchUsersAsMyData = [];
            forEach( content.item, item => {
                let newItem = {};
                newItem.id = item.identifier;
                newItem.name = item.name || item.localIdentifier;
                touchUsersAsMyData.push(newItem);
            });
            // console.log('touchUsersAsMyData',touchUsersAsMyData.length,touchUsersAsMyData);

            dispatch({
                type: RESOURCES,
                payload: { touchUsers: touchUsersAsMyData }
            });
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

export const getOrganizationTemplates = organizationId => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/user/templates`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { organizationTemplates: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const bindOrganizationUserWithTouchUser = (
  organizationId,
  userId,
  touchUserId,
  role
) => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/user/${userId}/bindWith/${touchUserId}?role=${role}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        })
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const deleteOrganizationUserBinding = (organizationId, userId) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organizationId}/user/unbind/${userId}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        })
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    //
    // force reload
    //
    // TODO: hack !!!!
    {
        getOrganizationUsersAdmin(organizationId);
        getOrganizationUsersOwner(organizationId);
        getOrganizationUsersUser(organizationId);
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const createOrganizationUser = (organizationId, user) => async (
    dispatch,
    getState
) => {

    let result = await postJSON_betterVersion({
        url: `${getApiPrefix_touch()}/organization/${organizationId}/user`,
        parametersAsStructure: user,
        showLoader: true,
        dispatch,
        getState,
        resultDataFormat: "json"
    });
    let userId = result.data;
    return userId;
};

export const removeHost = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/host/${id}`, {
      method: "DELETE"
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const removeServer = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/server/${id}`, {
      method: "DELETE"
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const removeOrganization = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/organization/${id}`, {
      method: "DELETE"
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateHost = host => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/host/${host.id}`, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(host)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateServer = server => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/server/${server.id}`, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(server)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateOrganization = organization => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${organization.id}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(organization)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const installPackage = (id, packageObject) => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/organization/${id}/package`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(packageObject)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError(response);
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getResourcesForAdmin = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/oauthResource/${id ? id : ""}`
    );

    if (response.status === 200) {
      const content = await response.json();

      if (id) {
        dispatch({
          type: RESOURCES,
          payload: { resource: content }
        });
      } else {
        dispatch({
          type: RESOURCES,
          payload: { resources: content }
        });
      }
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const addResource = resource => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/oauthResource/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(resource)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const updateResource = resource => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/oauthResource/${resource.id}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(resource)
      }
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const deleteResource = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/oauthResource/${id}`, {
      method: "DELETE"
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getUserResourcesRights = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_touch()}/oauthRight/forResource/${id}`
    );

    if (response.status === 200) {
      const content = await response.json();

      dispatch({
        type: RESOURCES,
        payload: { rights: content }
      });
    } else if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const addUserResourceRights = userResourceRights => async (
  dispatch,
  getState
) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/oauthRight/`, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(userResourceRights)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const deleteUserResourceRights = id => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/oauthRight/${id}`, {
      method: "DELETE"
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const editUserResourceRights = right => async (dispatch, getState) => {
  try {
    const response = await fetch(`${getApiPrefix_touch()}/oauthRight/${right.id}`, {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json"
      }),
      body: JSON.stringify(right)
    });

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getServerCategories = id => async (dispatch, getState) => {
    try {
        const response = await fetch(
            `${getApiPrefix_touch()}/server/category/`
        );

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 200) {
            const content = await response.json();
            dispatch({
                type: RESOURCES,
                payload: { serverCategories: content }
            });
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

export const getPage = id => async (dispatch, getState) => {
  try {
    const response = await fetch(
      `${getApiPrefix_lagoon()}/auth/requestResource/${id}`
    );

    if (
      (response.status === 401 || response.status === 403) &&
      getState().app.allowRedirect
    ) {
      dispatch(setAllowRedirect(false));
      const url = await response.text();
      redirectTo(url);
    } else if (response.status === 200) {
      const content = await response.json();
      dispatch({
        type: RESOURCES,
        payload: { page: content }
      });
    } else if (response.status === 500 || response.status === 503) {
      alertBackendError({response});
    }

    return response.status === 200;
  } catch (exception) {
    console.log(exception);
    alertBackendError({exception});
    return false;
  }
};

export const getHostCategories = id => async (dispatch, getState) => {
    try {
        const response = await fetch(
            `${getApiPrefix_touch()}/host/category/`
        );
        //
        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 200) {
            const content = await response.json();
            dispatch({
                type: RESOURCES,
                payload: { hostCategories: content }
            });
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }
        //
        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

export const addHostCategory = parametersAsStructure => async (dispatch, getState) => {
    dispatch(showLoader(true));
    try {
        const url = `${getApiPrefix_touch()}/host/category/`;
        const response = await fetch(url, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify(parametersAsStructure)
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {

            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);

        } else if (response.status === 304) {

            // TODO: handle modified
            console.log('url:', url, ' modified');

        } else if (response.status === 200) {

            dispatch(showLoader(false));

        } else if (response.status === 500 || response.status === 503) {

            alertBackendError();
            // dispatch(showLoader(false));

        }
        else
        {
            // other exotic error messages ...
            alertBackendError({response});
            dispatch(showLoader(false));
        }

        return response.status === 200;

    } catch (error) {

        console.log(error);
        alertBackendError();
        dispatch(showLoader(false));
        return false;
    }
};

export const editHostCategory = parametersAsStructure => async (dispatch, getState) => {

    // FIXME: not needed because add will work

};

export const addServerCategory = parametersAsStructure => async (dispatch, getState) =>
{
    return postJSON({ url: `${getApiPrefix_touch()}/server/category/`, parametersAsStructure, dispatch, getState });
};

const postJSON = async ({ url, parametersAsStructure, dispatch, getState }) =>
{
    dispatch(showLoader(true));
    try {
        const response = await fetch( url, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify( parametersAsStructure )
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {

            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);

        } else if (response.status === 304) {

            // TODO: handle modified
            console.log('url:', url, ' modified');

        } else if (response.status === 200) {

            dispatch(showLoader(false));

        } else if (response.status === 500 || response.status === 503) {

            alertBackendError();
            // dispatch(showLoader(false));

        }
        else
        {
            // other exotic error messages ...
            alertBackendError({response});
            dispatch(showLoader(false));
        }

        return response.status === 200;

    } catch (error) {

        console.log(error);
        alertBackendError();
        dispatch(showLoader(false));
        return false;
    }
};

//
// TODO: merge in future with postJSON
//
// - resultDataFormat: "text", "json"
// - showLoader: stop application and wait for result, show progressbar
// @returns      { ok, data }
const postJSON_betterVersion = async ( parameters ) =>
{
    let { url, parametersAsStructure, resultDataFormat, dispatch, getState } = parameters;
    let result = { ok: false, data: null };

    resultDataFormat = resultDataFormat || "json";

    if( parameters.showLoader )
    {
        dispatch(showLoader(true));
    }

    try {
        const response = await fetch( url, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify( parametersAsStructure )
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {

            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);

        } else if (response.status === 304) {

            // TODO: handle modified
            console.log('url:', url, ' modified');

        } else if (response.status === 200) {

            if( resultDataFormat === "text" )
            {
                const parsedData = await response.text();
                result.data = parsedData;
            }
            else if( resultDataFormat === "json" )
            {
                const parsedData = await response.json();
                result.data = parsedData;
            }

        } else if (response.status === 500 || response.status === 503) {

            alertBackendError();
        }
        else
        {
            // other exotic error messages ...
            alertBackendError({response});
        }

        result.ok = response.status === 200;

    } catch (error) {
        console.log(error);
        alertBackendError();
    }

    if( parameters.showLoader )
    {
        dispatch(showLoader(false));
    }

    return result;
};


// WEBPACK FOOTER //
// ./src/actions/resourceActions.js